import indexeddb from '@/ddv2.library/indexeddb'

export default {
  /**
   * GoogleMap用住所取得
   * @param {} list
   */
  getAddressStrings: function (master, list) {
    var addressInfo = ''
    // 年月日時刻順にソート
    list.sort(function (a, b) {
      if (a.ymdhms < b.ymdhms) return -1
      if (a.ymdhms > b.ymdhms) return 1
      return 0
    })

    list.forEach(function (item) {
      const d = indexeddb.getRecord(master, item.id)
      var areaString = null
      if (![undefined, null].includes(d)) {
        if (d.jusho !== '' & d.jusho !== null) {
          areaString = d.jusho
        } else {
          areaString = d.hacchakuchiNm
        }
      }
      if (![undefined, null, ''].includes(item.biko)) {
        areaString = areaString === null ? item.biko : areaString + ' ' + item.biko
      }
      if (areaString !== null) {
        addressInfo = addressInfo + '/' + areaString
      }
    })

    return addressInfo
  }
}
